module.exports = __webpack_public_path__ + "assets/img/HF.622a6c31.png";